<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <page-header class="py-4 pb-6">
      {{ $t('menu') }}
      <template #subtitle>
        {{ $t('introduceOfMenu') }}
      </template>
    </page-header>
    <loading-provider :loading="loading">
      <div
        style="display: grid;grid-template-columns: repeat(auto-fill,minmax(250px,1fr));grid-gap: 24px;"
      >
        <consume-type-info-card
          v-for="(c,i) in consumeTypeList"
          :key="c.id"
          :consume-type-id="c.id"
          :consume-type-info="c"
          @changehotpotstatus="changeHotpotStatus(c)"
          @click="startEditConsumeType(i)"
          @configuration="configurationCategory(c)"
          @copy="copyMenu(c)"
          @delete="deleteAndReload(c.id)"
          @dish-click="setDishFor(c.id)"
          @time-click="setTimeFor(c.id)"
          @price-click="setDishPriceFor(c.id)"
          @setting-click="startEditConsumeTypeSetting(c.id)"
        />
        <v-card
          class="pa-4 d-flex align-center justify-center"
          color="#eee"
          elevation="0"
          height="360"
          @click="startEditConsumeType(-1)"
        >
          <div class="text-center">
            <v-icon size="48">
              mdi-plus
            </v-icon>
            <div>
              {{ $t('addNewMenu') }}
            </div>
          </div>
        </v-card>
      </div>
    </loading-provider>

    <nice-dialog
      v-model="showTimeDialog"
      class="d-flex flex-wrap"
    >
      <time-picker
        :time-list="buffetTimeSpanList"
        @changed="saveChangedData"
        @close-dialog="showTimeDialog = false"
      />
    </nice-dialog>
    <nice-dialog
      v-model="showDishPriceDialog"
      class="d-flex"
    >
      <buffet-price-dish-fragment
        :consume-type-id="activeConsumeTypeIndex"
        @close-dialog="showDishPriceDialog = false"
      />
    </nice-dialog>
    <v-dialog
      v-model="showDishDialog"
      :max-width="900"
    >
      <div class="d-flex align-center white flex-wrap">
        <show-dish-card
          :close="showDishDialog"
          :filter="filter"
          @close="showDishDialog=false"
        />
      </div>
    </v-dialog>

    <ik-entity-form
      v-model="showConsumeTypeDialog"
      :edited-index="activeConsumeTypeIndex"
      :model="ConsumeType"
      :out-side-list="consumeTypeList"
      :title="$t('menu')"
      @need-refresh="reload"
    />
    <ik-entity-form
      v-model="showConsumeSettingDialog"
      :edited-index="realSettingIndex"
      :model="BuffetSetting"
      :out-side-list="consumeSettingList"
      :out-side-property="filter"
      :show-add-more-button="false"
      :title="$t('dinnerSet')"
      @need-refresh="reload"
    />
    <v-dialog
      v-model="copySchedule"
      max-width="400px"
      persistent
    >
      <v-card>
        <div
          class="pa-4 py-6 text-center"
        >
          <div class="text-h3">
            {{ $t('copyMenuNow') }}
          </div>
          <div
            class="text-body-1 mt-2"
            v-html="log"
          />
          <div
            v-if="finishedDishCount === copyDishList.length"
            class="mt-2"
          >
            <v-icon
              color="success"
              left
            >
              mdi-check
            </v-icon>
            {{ $t('copy_success_close_after_2_seconds') }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="consumeTypeCategoryDialog"
      max-width="800"
      persistent
    >
      <v-card
        class="pa-4"
      >
        <div class="d-flex align-center">
          <div class="text-h3">
            {{ $t('ConfigurationMenu') }}: <span class="font-weight-bold">{{ selectedConsumeType?.name }}</span>
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="consumeTypeCategoryDialog = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div
          v-dragscroll
          style="max-height: calc(100vh - 280px);overflow:hidden"
        >
          <div
            class="mt-4"
            style="display: grid;grid-template-columns: repeat(4,1fr);grid-gap: 8px"
          >
            <v-card
              v-for="item in realList"
              :key="item.id"
              class="text-body-2 pa-4"
              elevation="0"
              outlined
              @click="changeCategoryStatus(item)"
            >
              <v-responsive
                :aspect-ratio="1"
                class="align-center"
                style="position: relative"
              >
                <div
                  class="d-flex align-center justify-center flex-column"
                  style="height: 100%"
                >
                  <div class="text-body-1 font-weight-medium">
                    {{ item._langsname }}
                  </div>
                  <div class="mt-8 d-flex justify-center align-center">
                    <v-icon
                      v-if="item.requireCount === '1'"
                      class="mt-1"
                      color="green"
                      large
                    >
                      mdi-check
                    </v-icon>
                  </div>
                </div>
              </v-responsive>
            </v-card>
          </div>
        </div>
        <div
          style="position: absolute;bottom: 0;right: 16px"
        >
          <v-btn
            class="amber lighten-4 black--text my-2"
            elevation="0"
            outlined
            @click="saveCategoryChanged"
          >
            {{ $t('save') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IkEntityForm from '@/plugins/EntityFrameWork/IkEntityForm.vue'
import BuffetSetting from '@/model/dataLayer/api/buffet/BuffetSetting'
import ConsumeType from '@/model/dataLayer/api/buffet/ConsumeType'
import BuffetTimeSpan from '@/model/dataLayer/api/buffet/BuffetTimeSpan'
import BuffetPrice from '@/model/dataLayer/api/buffet/BuffetPrice'
import NiceDialog from '@/views/widget/uiComponent/NiceDialog.vue'
import PageHeader from '@/views/widget/typography/PageHeader'
import ConsumeTypeInfoCard from '@/views/AadenPages/dishes/dish-display/widget/ConsumeTypeInfoCard'
import BuffetPriceDishFragment from '@/views/AadenPages/dishes/dish-display/widget/BuffetPriceDishFragment'
import ShowDishCard from '@/views/AadenPages/dishes/dish-display/widget/DishVisibilityFragment.vue'
import DishesConsumeType from '@/model/dataLayer/api/buffet/DishesConsumeType'
import TimePicker from '@/views/AadenPages/components/TimePicker/TimePicker'
import dayjs from 'dayjs'

import { groupBy } from 'lodash'
import { dragscroll } from 'vue-dragscroll/src/main'
import {
  addDefaultHotPotAGAndA,
  addHotpotBaseDish,
  setConsumeTypeCategoryRequireCount,
  showConsumeTypeCategoryRequire
} from '@/model/dataLayer/service/otherService'
import { showSuccessMessage } from '@/model/utils/utils'
import category from '@/model/dataLayer/api/dish/Category'
import LoadingProvider from '@/views/widget/LoadingProvider'
import { today } from '@/model/utils/DateRepository'

export default {
  components: {
    LoadingProvider,
    // AddDishes,
    // UploadDishPage,
    ShowDishCard,
    BuffetPriceDishFragment,
    ConsumeTypeInfoCard,
    PageHeader,
    NiceDialog,
    IkEntityForm,
    TimePicker
  },
  directives: {
    dragscroll
  },
  data: function () {
    return {
      allConsumeTypeRequireList: [],
      allCategoryList: [],
      categoryModel: category,
      selectedConsumeType: null,
      consumeTypeCategoryDialog: false,
      loading: false,
      log: '',
      menuCopy: [],
      finishedDishCount: null,
      finishedBuffetSettingCount: null,
      finishedPriceCount: null,
      finishedTimeCount: null,
      copyDishList: [],
      copySchedule: null,
      tab: 0,
      // BuffetChild: BuffetChild,
      BuffetSetting,
      ConsumeType,
      showTimeDialog: false,
      showDishDialog: false,
      showDishPriceDialog: false,
      buffetTimeSpanModel: BuffetTimeSpan,
      buffetPriceModel: BuffetPrice,
      activeConsumeTypeIndex: null,
      showConsumeTypeDialog: null,
      consumeTypeList: [],
      showConsumeSettingDialog: null,
      consumeSettingList: [],
      showUploadDishDialog: false,

      buffetTimeSpanList: []
    }
  },
  computed: {
    realList () {
      const res = groupBy(this.allConsumeTypeRequireList, 'categoryId')
      for (const categoryItem of this.allCategoryList) {
        const requireCountArr = res[categoryItem.id]
        categoryItem.requireCount = requireCountArr ? requireCountArr[0].requireCount : '0'
      }
      return this.allCategoryList
    },
    filter: function () {
      return this.activeConsumeTypeIndex ? { consumeTypeId: this.activeConsumeTypeIndex } : { consumeTypeId: 1 }
    },
    realSettingIndex: function () {
      return this.consumeSettingList.findIndex(it => it.consumeTypeId === this.activeConsumeTypeIndex)
    }
  },
  watch: {
    showDishDialog (val) {
      if (!val) {
        this.reload()
      }
    },
    showTimeDialog (val) {
      if (!val) {
        this.reload()
      }
    },
    showDishPriceDialog (val) {
      if (!val) {
        this.reload()
      }
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    async changeHotpotStatus (item) {
      if (item.isHotpot !== '1') {
        item.isHotpot = '1'
        await addDefaultHotPotAGAndA()
        await addHotpotBaseDish()
      } else {
        item.isHotpot = '0'
      }
      await ConsumeType.edit(item)
      await showSuccessMessage(this.$t('ChangeSuccessfully'))
    },
    async saveCategoryChanged () {
      const res = this.allCategoryList.map(it => {
        return {
          consumeTypeId: this.selectedConsumeType.id,
          categoryId: it.id,
          requireCount: it.requireCount
        }
      })
      await setConsumeTypeCategoryRequireCount(res)
      this.consumeTypeCategoryDialog = false
    },
    changeCategoryStatus (item) {
      item.requireCount = item.requireCount === '0' ? '1' : '0'
    },
    async configurationCategory (item) {
      this.allConsumeTypeRequireList = await showConsumeTypeCategoryRequire(item.id)
      this.selectedConsumeType = item
      this.consumeTypeCategoryDialog = true
    },
    closeDialog () {
      this.copySchedule = false
      this.reload()
    },
    async copyMenu (c) {
      this.copySchedule = true
      c.langs.forEach(function (value) {
        switch (value.lang) {
          case 'DE':
            value.name += 'Kopie'
            break
          case 'ZH':
            value.name += '复制品'
            break
          case 'EN':
            value.name += 'Copy'
            break
        }
      })
      this.log = ''
      this.finishedDishCount = 0
      this.finishedPriceCount = 0
      this.finishedTimeCount = 0
      this.finishedBuffetSettingCount = 0
      this.log += '<div>' + this.$t('start_create_menu') + '</div>'
      this.activeConsumeTypeIndex = c.id
      this.copyDishList = (await DishesConsumeType.getList(true, this.filter)).filter(item => item.showing === true)
      try {
        this.menuCopy = await ConsumeType.add(c)
        this.log += this.$t('create_menu_successfully') + '<br>'
      } catch (e) {
        this.log += this.$t('failed_to_create_menu') + '<br>'
        return
      }
      this.getBuffetSetting = (await BuffetSetting.getList(true)).filter(a => a.consumeTypeId === c.id)
      this.priceList = (await BuffetPrice.getList(true)).filter(b => b.consumeTypeId === c.id)
      this.timeList = (await BuffetTimeSpan.getList(true, this.filter)).filter(d => d.consumeTypeId === c.id)
      // 可用时间
      try {
        for (const item of this.timeList) {
          item.consumeTypeId = parseInt(this.menuCopy.content[0].id)
          await BuffetTimeSpan.add(item)
          this.finishedTimeCount++
          this.log += this.$t('copying_time_setting') + this.finishedTimeCount + '/' + this.timeList.length + '<br>'
          if (this.finishedTimeCount !== this.timeList.length + 1) {
            this.log = this.log.replace(
              this.$t('copying_time_setting') + (this.finishedTimeCount - 1) + '/' + this.timeList.length + '<br>',
              ' ')
          }
        }
      } catch (e) {
        this.failedTimeCopy = this.failedTimeCopy + 1
        this.log += this.$t('error') + this.failedPriceCopy + this.$t('one(unit)')
      }
      // 自助价格
      try {
        for (const item of this.priceList) {
          item.consumeTypeId = parseInt(this.menuCopy.content[0].id)
          item.code = item.code + item.consumeTypeId
          await BuffetPrice.add(item)
          this.finishedPriceCount = this.finishedPriceCount + 1
          this.log += this.$t(
            'copying_price_setting') + this.finishedPriceCount + '/' + this.priceList.length + '<br>'
          if (this.finishedPriceCount !== this.priceList.length + 1) {
            this.log = this.log.replace(
              this.$t('copying_price_setting') + (this.finishedPriceCount - 1) + '/' + this.priceList.length + '<br>',
              ' ')
          }
        }
      } catch (e) {
        this.failedPriceCopy = this.failedPriceCopy + 1
        this.log += this.$t('error') + this.failedPriceCopy + this.$t('one(unit)')
      }
      // 包餐设置
      try {
        for (const item of this.getBuffetSetting) {
          item.consumeTypeId = parseInt(this.menuCopy.content[0].id)
          await BuffetSetting.add(item)
          this.finishedBuffetSettingCount = this.finishedBuffetSettingCount + 1
          this.log += this.$t(
            'copying_buffet_setting') + this.finishedBuffetSettingCount + '/' + this.getBuffetSetting.length + '<br>'
          if (this.finishedBuffetSettingCount !== this.getBuffetSetting.length + 1) {
            this.log = this.log.replace(this.$t(
              'copying_buffet_setting') + (this.finishedBuffetSettingCount - 1) + '/' + this.getBuffetSetting.length + '<br>',
            ' ')
          }
        }
      } catch (e) {
        this.failedPriceCopy = this.failedPriceCopy + 1
        this.log += this.$t('error') + this.failedPriceCopy + this.$t('one(unit)')
      }
      // 产品中的产品
      try {
        for (const item of this.copyDishList) {
          item.consumeTypeId = parseInt(this.menuCopy.content[0].id)
          await DishesConsumeType.edit(item)
          this.finishedDishCount = this.finishedDishCount + 1
          this.log += this.$t(
            'copying_product_setting') + ': ' + this.finishedDishCount + '/' + this.copyDishList.length + '<br>'
          if (this.finishedDishCount !== this.copyDishList.length + 1) {
            this.log = this.log.replace(this.$t(
              'copying_product_setting') + ': ' + (this.finishedDishCount - 1) + '/' + this.copyDishList.length + '<br>',
            ' ')
          }
        }
      } catch (e) {
        this.failedDishCopy = this.failedDishCopy + 1
        this.log += this.$t('error') + this.failedPriceCopy + this.$t('one(unit)')
      }
      setTimeout(() => {
        this.closeDialog()
      }, 2000)
    },

    startEditConsumeTypeSetting (id) {
      this.showConsumeSettingDialog = true
      this.activeConsumeTypeIndex = id
    },

    startEditConsumeType (index) {
      this.showConsumeTypeDialog = true
      this.activeConsumeTypeIndex = index
    },

    async setTimeFor (id) {
      this.activeConsumeTypeIndex = id
      this.buffetTimeSpanList = (await this.buffetTimeSpanModel.getList(true, this.filter)).map(it => {
        it.startTime = dayjs(today + ' ' + it.fromTime).format('HH:mm')
        it.endTime = dayjs(today + ' ' + it.toTime).format('HH:mm')
        return it
      })
      this.showTimeDialog = true
    },

    setDishPriceFor (id) {
      this.showDishPriceDialog = true
      this.activeConsumeTypeIndex = id
    },
    setDishFor (id) {
      this.showDishDialog = true
      this.activeConsumeTypeIndex = id
    },
    async deleteAndReload (id) {
      await ConsumeType.remove(id)
      await this.reload()
    },
    async saveChangedData (
      arr
    ) {
      for (const buffet of this.buffetTimeSpanList) {
        await this.buffetTimeSpanModel.remove(buffet.id)
      }
      for (const item of arr) {
        await this.buffetTimeSpanModel.add({
          fromTime: item.startTime,
          toTime: item.endTime,
          consumeTypeId: this.activeConsumeTypeIndex,
          dayOfWeek: [item.dayOfWeek].flat()
        })
      }
      this.showTimeDialog = false
    },
    async reload () {
      this.loading = true
      this.allCategoryList = (await category.getList(true))
      this.allCategoryList.forEach(it => {
        this.$set(it, 'requireCount', 0)
      })
      this.consumeTypeList = (await ConsumeType.getList(true))
      this.consumeSettingList = (await BuffetSetting.getList(true)).filter(it => ![3, 4].includes(it.id))
      this.loading = false
    }
  }
}
</script>
